import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { Image } from 'react-bootstrap'
// Styles
import * as s from './ItemBlog.module.scss'

const ItemBlog = ({ className, heading, image, link, ...rest }) => {
  return (
    <div {...rest} className={cn(s.itemBlog, className)}>
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={heading}
      >
        <Image src={image} fluid className={s.blogImg} />
      </a>
      <div className={s.titleContainer}>
        <h3 className={cn('h5', s.heading)}>
          {heading.replace(/(&lt;&gt;)/g, ' ')}
        </h3>
      </div>
    </div>
  )
}

ItemBlog.defaultProps = {
  className: undefined,
}

ItemBlog.propTypes = {
  className: PropTypes.string,
  heading: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
}

export default ItemBlog
